import { TranslationKey, translationKey } from 'intl/types/translationKey';

/**
 * AUTO-GENERATED — do not edit manually.
 * Run `yarn generate:translation-keys` after changing messages.en.json.
 */
export const UserTranslationKeys = {
  changeConfirmationDescription: translationKey('access_change_confirmation_description'),
  changeConfirmationTitle: translationKey('access_change_confirmation_title'),
  changeFailed: translationKey('access_change_failed'),
  managementName: translationKey('access_management_name'),
  managementPermission: translationKey('access_management_permission'),
  managementRole: translationKey('access_management_role'),
  addUserSection: translationKey('add_user_section'),
  call: translationKey('call'),
  editUserSection: translationKey('edit_user_section'),
  mentionUser: translationKey('mention_user'),
  noPhoneNumber: translationKey('no_phone_number'),
  openDetailedView: translationKey('open_detailed_view'),
  phoneNumber: translationKey('phone_number'),
  removeClientAdminFromProjects: translationKey('remove_client_admin_from_projects'),
  removeClientAdminFromProjectsDialogBody: translationKey('remove_client_admin_from_projects_dialog_body'),
  removeClientAdminFromProjectsDialogTitle: translationKey('remove_client_admin_from_projects_dialog_title'),
  removeUserCompletely: translationKey('remove_user_completely'),
  removeUserCompletelyFromOrganization: translationKey('remove_user_completely_from_organization'),
  removeUserCompletelyFromOrganizationDialogConsequences: translationKey('remove_user_completely_from_organization_dialog_consequences'),
  removeUserCompletelyFromOrganizationDialogTitle: translationKey('remove_user_completely_from_organization_dialog_title'),
  removeUserCompletelyFromProject: translationKey('remove_user_completely_from_project'),
  removeUserCompletelyFromProjectDialogConsequences: translationKey('remove_user_completely_from_project_dialog_consequences'),
  removeUserCompletelyFromProjectDialogTitle: translationKey('remove_user_completely_from_project_dialog_title'),
  removeUserFromProject: translationKey('remove_user_from_project'),
  removeUserFromProjectDialogBody: translationKey('remove_user_from_project_dialog_body'),
  removeUserFromProjectDialogTitle: translationKey('remove_user_from_project_dialog_title'),
  revokeInOrganizationDialogBody: translationKey('revoke_in_organization_dialog_body'),
  revokeInOrganizationDialogTitle: translationKey('revoke_in_organization_dialog_title'),
  revokeInProjectDialogBody: translationKey('revoke_in_project_dialog_body'),
  revokeInProjectDialogTitle: translationKey('revoke_in_project_dialog_title'),
  revokePermissionsInThisOrganization: translationKey('revoke_permissions_in_this_organization'),
  revokePermissionsInThisProject: translationKey('revoke_permissions_in_this_project'),
  admin: translationKey('role_admin'),
  explanationManager: translationKey('role_explanation_manager'),
  explanationOrganizationAdmin: translationKey('role_explanation_organization_admin'),
  explanationProjectAdmin: translationKey('role_explanation_project_admin'),
  explanationStandard: translationKey('role_explanation_standard'),
  explanationSuperAdmin: translationKey('role_explanation_super_admin'),
  explanationViewer: translationKey('role_explanation_viewer'),
  explanationVisibleNoAccess: translationKey('role_explanation_visible_no_access'),
  manager: translationKey('role_manager'),
  projectAdmin: translationKey('role_project_admin'),
  standard: translationKey('role_standard'),
  viewer: translationKey('role_viewer'),
  visibleNoAccess: translationKey('role_visible_no_access'),
  setAdminRoleDialogBody: translationKey('set_admin_role_dialog_body'),
  setAdminRoleDialogTitle: translationKey('set_admin_role_dialog_title'),
  setClientAdminRoleDialogBody: translationKey('set_client_admin_role_dialog_body'),
  setClientAdminRoleDialogTitle: translationKey('set_client_admin_role_dialog_title'),
  titleAccessManagement: translationKey('title_access_management'),
  accessEdit: translationKey('user_access_edit'),
  accessEditExplanation: translationKey('user_access_edit_explanation'),
  accessNone: translationKey('user_access_none'),
  accessNoneExplanation: translationKey('user_access_none_explanation'),
  accessRead: translationKey('user_access_read'),
  accessReadExplanation: translationKey('user_access_read_explanation'),
  cardAccountDeleted: translationKey('user_card_account_deleted'),
  cardEditDropdown: translationKey('user_card_edit_dropdown'),
  cardNoAccessWarning: translationKey('user_card_no_access_warning'),
  cardNoIssueAccess: translationKey('user_card_no_issue_access'),
  cardNoPermissionsRole: translationKey('user_card_no_permissions_role'),
  cardNoProcessAccess: translationKey('user_card_no_process_access'),
  cardNoProcessAccessGeneric: translationKey('user_card_no_process_access_generic'),
  cardNoSiteAccess: translationKey('user_card_no_site_access'),
  cardNoSiteAccessGeneric: translationKey('user_card_no_site_access_generic'),
  cardWriteMessage: translationKey('user_card_write_message'),
  email: translationKey('user_email'),
  formAdminAllSitesAllProcessesInfo: translationKey('user_form_admin_all_sites_all_processes_info'),
  formVisibleNoAccessNoSitesNoProcessesInfo: translationKey('user_form_visible_no_access_no_sites_no_processes_info'),
  label: translationKey('user_label'),
  phone: translationKey('user_phone'),
  viewDataMessage: translationKey('user_view_data_message'),
  viewHeader: translationKey('user_view_header'),
  viewNameInputLabel: translationKey('user_view_name_input_label'),
} as const satisfies Record<string, TranslationKey>;
